// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e1aeb96c","453":"1b9bc977","455":"a1a25785"}[chunkId] + ".chunk.js";
};